<div class="container">
  <div class="tabs-container">
    <div class="tab" [class.active]="yourMindLogIsActive" (click)="activateTab('mindLog')">{{'historical.your_logs' | translate}}</div>
    @if(this.authService.user()?.profile === PROFILES.PSYCHOLOGIST.key){
      <div class="tab" [class.active]="sharedWithYouIsActive" (click)="activateTab('shared')">{{'historical.shared_with_you' | translate}}</div>
    }
  </div>
    <!--  HIDDEN MUST BE USED TO ANGULAR NOT DESTROY THE COMPONENT AFTER VIEWTYPE CHANGE-->
    <app-list [hidden] = "viewType !== DATAVIEW.LIST"
      [yourMindLogIsActive]="yourMindLogIsActive"
      [sharedWithYouIsActive]="sharedWithYouIsActive"
      [listLogs]="list()"
      [loadingLogs]="loading()"
      [loadingSharedLogs]="loadingShared()"
      [listShared]="listShared()"
      [psychologist]="psychologist()"
      [filterBy]="userFiltered"
      (userSelected)="filterByUser($event)"
    ></app-list>

    <!--  HIDDEN MUST BE USED TO ANGULAR NOT DESTROY THE COMPONENT AFTER VIEWTYPE CHANGE-->
    <app-streak [hidden] = "viewType !== DATAVIEW.STREAK"
      [yourMindLogIsActive]="yourMindLogIsActive"
      [sharedWithYouIsActive]="sharedWithYouIsActive"
      [listLogs]="list()"
      [loadingLogs]="loading()"
      [loadingSharedLogs]="loadingShared()"
      [listShared]="listShared()"
      [psychologist]="psychologist()"
      [filterBy]="userFiltered"
      (userSelected)="filterByUser($event)">
    </app-streak>

    <!--  HIDDEN MUST BE USED TO ANGULAR NOT DESTROY THE COMPONENT AFTER VIEWTYPE CHANGE-->
    <app-mood-progress [hidden] = "viewType !== DATAVIEW.PROGRESS"
      [yourMindLogIsActive]="yourMindLogIsActive"
      [sharedWithYouIsActive]="sharedWithYouIsActive"
      [listLogs]="list()"
      [loadingLogs]="loading()"
      [loadingSharedLogs]="loadingShared()"
      [listShared]="listShared()"
      [psychologist]="psychologist()"
      [filterBy]="userFiltered"
      (userSelected)="filterByUser($event)">
    </app-mood-progress>
  <div class="visualizer-container">
      <div (click)="toggleMenuOpen()" [matMenuTriggerFor]="viewMenu">
        <span>{{ 'historical.visualizer' | translate }}</span>
        @if(isMenuOpened){
          <mat-icon>keyboard_arrow_up</mat-icon>
        }@else {
          <mat-icon>keyboard_arrow_down</mat-icon>
        }
      </div>
    </div>
</div>

<mat-menu #viewMenu="matMenu" class="menu" yPosition="above" (closed)="toggleMenuOpen()">
    <div mat-menu-item>
      <button mat-menu-item (click)="changeView('list')"><mat-icon>list</mat-icon>{{ 'historical.list' | translate}}</button>
      <button mat-menu-item (click)="changeView('streak')"><mat-icon>apps</mat-icon>{{ 'historical.streak' | translate}}</button>
      <button mat-menu-item (click)="changeView('progress')"><mat-icon>show_chart</mat-icon>{{ 'historical.progress' | translate}}</button>
    </div>
</mat-menu>
